import {IEditor, IEditorImage, Imports} from "../editor.interfaces";



/* tslint:disable no-invalid-this */

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

const fabric = globalImports.fabric || (globalImports.fabric = {});
const SF = globalImports.SF || {};
SF.Editor = SF.Editor || {} as IEditor;
globalImports.SF.Edior = globalImports.SF.Editor || {};

globalImports.SF.Editor.Clipart = fabric.util.createClass(globalImports.SF.Editor.Image, {
    type: 'clipart',

    initialize: function (image:IEditorImage, options:{flipX: boolean, flipY: boolean, effects: {flipHorizontal:boolean, flipVertical:boolean}}):void {
        if (options.effects) {
            if (options.effects.flipHorizontal) {
                options.flipX = true;
            }

            if (options.effects.flipVertical) {
                options.flipY = true;
            }
        }
        this.callSuper('initialize', image, options);
    },

    resetAspectRatio: function ():void {
        this.set('height', this.width * (this.image.height / this.image.width));

        // set coords and check if the clipart is too big
        this.setCoords();
        const boundingRect = this.getBoundingRect();
        const canvasHeight = this.canvas.height - this.canvas.marginTop - this.canvas.marginBottom;

        if (boundingRect.height > canvasHeight) {
            const scaleToReduceBy = (canvasHeight * 0.9) / boundingRect.height;
            this.set('width', this.width * scaleToReduceBy);
            this.set('height', this.height * scaleToReduceBy);
        }
    },

    toObject: function (propertiesToInclude:any):Object {
        const o = this.callSuper('toObject', propertiesToInclude);

        // pass along flipping information
        if (this.flipY) {
            o.effects.flipVertical = true;
        }

        if (this.flipX) {
            o.effects.flipHorizontal = true;
        }

        return o;
    }
});